import { useMemo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { TimeSignal } from 'graphql/types';

export const getDefaultValues = (
  notes: TimeSignal[]
): Record<string, boolean> => {
  const notesKey = notes.reduce((acc, note) => {
    acc[`${note.date}_${note.id}`] = false;
    return acc;
  }, {} as Record<string, boolean>);
  return {
    selectAll: false,
    ...notesKey
  };
};

export const useTimelineNotesForm = (notes: TimeSignal[]): void => {
  const defaultValues = useMemo<Record<string, boolean>>(
    () => getDefaultValues(notes),
    [notes]
  );

  const { register } = useFormContext<Record<string, boolean>>();
  useEffect(() => {
    Object.keys(defaultValues).forEach((key) => {
      register(key);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);
};
